import { useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";

// Campo de formulário do app original: label MAIÚSCULA 10px letterspacing
// 1.2, input radius 12 / py-14 / fontSize 15.
//
// Dois "tons", como na referência:
// - "auth"    → telas de login/cadastro sobre surface-alt: fundo
//               rgba(255,255,255,0.08) e borda rgba(255,255,255,0.14)
// - "default" → telas internas: fundo card e borda input
type Tone = "auth" | "default";

const TONE_CLASSES: Record<Tone, string> = {
  auth: "bg-white/8 border-white/14 text-surface-alt-foreground placeholder:text-surface-alt-foreground/40",
  default:
    "bg-card border-input text-foreground placeholder:text-muted-foreground/60",
};

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "className"> & {
  label: string;
  tone?: Tone;
  error?: string | null;
};

export function Field({ label, tone = "default", error, type, ...rest }: Props) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const labelColor =
    tone === "auth"
      ? "text-surface-alt-foreground/70"
      : "text-secondary-foreground";

  return (
    <label className="flex flex-col">
      <span
        className={`mb-1.5 text-[10px] font-semibold tracking-[1.2px] ${labelColor}`}
      >
        {label.toUpperCase()}
      </span>
      <div className="relative">
        <input
          type={isPassword && showPassword ? "text" : type}
          className={`w-full rounded-(--radius-field) border px-4 py-3.5 text-[15px] outline-none transition-colors focus:border-tint ${TONE_CLASSES[tone]} ${isPassword ? "pr-12" : ""}`}
          {...rest}
        />
        {isPassword && (
          <button
            type="button"
            tabIndex={-1}
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            className="absolute inset-y-0 right-0 flex w-12 items-center justify-center text-muted-foreground"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        )}
      </div>
      {error && <span className="mt-1.5 text-xs text-[#ffb4ad]">{error}</span>}
    </label>
  );
}
